import request from '../http';

// baseURL 已是 /api，这里只写相对路径，否则会变成 /api/api/xxx
export const login = (data) =>
  request({ url: '/system/auth/login', method: 'post', data });

export const me = () =>
  request({ url: '/system/auth/me', method: 'get' });

export const logout = () =>
  request({ url: '/system/auth/logout', method: 'post' });

export const getCodeImg = () =>
  request({ url: '/captchaImage', method: 'get' });
